import { render, staticRenderFns } from "./AiSearchBar.vue?vue&type=template&id=1767043a&scoped=true"
import script from "./AiSearchBar.vue?vue&type=script&lang=js"
export * from "./AiSearchBar.vue?vue&type=script&lang=js"
import style0 from "./AiSearchBar.vue?vue&type=style&index=0&id=1767043a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767043a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1767043a')) {
      api.createRecord('1767043a', component.options)
    } else {
      api.reload('1767043a', component.options)
    }
    module.hot.accept("./AiSearchBar.vue?vue&type=template&id=1767043a&scoped=true", function () {
      api.rerender('1767043a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/banner-builder/AiSearchBar.vue"
export default component.exports